<mat-form-field
  appearance="outline"
  class="w-100 {{ formFieldClass }}"
  [ngStyle]="{ 'font-size': fontSize }"
  [ngClass]="{
    'form-density-3 button-density-3 form-field-condensed': isInToolbar,
    'inverted-color': invertedColor,
  }"
  subscriptSizing="dynamic"
>
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <input matInput [formControl]="formControl" [placeholder]="placeholder" />
  @if (hasSearchIcon) {
    <mat-icon matPrefix>search</mat-icon>
  }

  @if (hasCancelButton && formControl.value) {
    <button mat-icon-button class="mr-1" matSuffix (click)="clearSearchField()">
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>
